import { jsxs as i, jsx as l } from "react/jsx-runtime";
import t from "../../../svg-icon/svg-icon.component.js";
function r(C) {
  return /* @__PURE__ */ i(
    t,
    {
      width: "86",
      height: "38",
      viewBox: "0 0 86 38",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...C,
      children: [
        /* @__PURE__ */ i("g", { clipPath: "url(#DefaultBrandMarkMono-clip0_34574_1977)", children: [
          /* @__PURE__ */ l(
            "path",
            {
              d: "M0.0856934 4.10944H6.85154V10.8384H15.0868V16.8026H6.85154V27.0762C6.85154 29.2983 7.66862 30.7351 10.5104 30.7351H15.0868V36.6993H10.5104C2.06575 36.6984 0.0856934 32.0053 0.0856934 26.6754V4.10944Z",
              fill: "black"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              d: "M17.908 4.10945C17.908 1.32776 20.2751 0.0497742 22.0174 0.0497742C24.2326 0.0497742 26.0762 1.82041 26.0762 4.10945C26.0762 6.0629 24.4781 8.21891 22.0174 8.21891C19.2632 8.21891 17.908 5.80285 17.908 4.10945ZM18.61 36.6985V10.8384H25.3759V36.6985H18.61Z",
              fill: "black"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              d: "M53.5808 15.5237C51.8625 12.3172 48.5942 10.3363 44.4598 10.3363C39.7041 10.3363 37.1721 13.2132 36.3911 14.2131V10.8384H29.6252V36.6984H36.3911V22.2149C36.3911 19.9027 37.6613 18.1097 39.2732 17.2283C40.1581 16.7442 41.1528 16.5013 42.2549 16.5013C43.4239 16.5013 44.4512 16.7442 45.337 17.2283C47.0441 18.1612 48.1187 19.901 48.1187 22.2149V36.6984H54.8845V21.0116C54.8845 18.974 54.4502 17.145 53.5816 15.5237H53.5808Z",
              fill: "black"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              d: "M65.7221 26.4746C65.1625 24.9219 64.8758 22.4312 66.1693 20.0598C67.3468 17.9003 69.4702 16.552 72.0828 16.552C75.0001 16.552 76.9802 18.1964 77.9964 20.0598C79.2315 22.3248 79.0341 24.8361 78.4436 26.4746H85.66C85.8497 25.4978 86.6041 21.1592 84.085 16.9528C81.7059 12.9798 77.3896 10.3371 72.082 10.3371C66.4782 10.3371 62.2924 13.2527 60.0789 16.9528C57.5718 21.1429 58.3022 25.4352 58.5039 26.4746H65.7212H65.7221Z",
              fill: "black"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              d: "M60.3192 30.9848C62.4589 34.3416 66.4293 37.1997 72.082 37.1997C77.0841 37.1997 81.3746 34.8583 83.8448 30.9848H60.3184H60.3192Z",
              fill: "black"
            }
          )
        ] }),
        /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "clip0_34574_1977", children: /* @__PURE__ */ l("rect", { width: "85.9999", height: "37.2495", fill: "white" }) }) })
      ]
    }
  );
}
export {
  r as DefaultBrandMarkMonoLogo
};
//# sourceMappingURL=mono.js.map
